export const CURRENT_CONFIG = {

  // license
  appId: '148794', // You need to go to the development website to apply.
  appKey: 'd92dc9e6fe7b0060acacb7c037bbd33', // You need to go to the development website to apply.
  appLicense: 'bQPK+eCt5obN+4Gpk8R3++nc7+jCYQfbURI84MH+w1GYsNVna4VqjMf+pMk1NF7KmKQrswkDnSuZEaSeNhPzd08XX+iCmmxFa2uVZBt90v3kTgDEBkDaGThE+sumO7xegn8q32R+vUwI9UMuhA2pmrWWRfZd78CGWlWLWClDc7c=', // You need to go to the development website to apply.

  // http
  baseURL: 'https://backend.cvis.videri.ai/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: 'wss://backend.cvis.videri.ai/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'rtmp://media.cvis.videri.ai/', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'Please enter the amap key.',

}
